"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { ArrowRight, BookOpen, Calendar } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { AspectRatio } from "@/components/ui/aspect-ratio";
function PostsGrid() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map(i => <Card key={i} data-index={i} className="border-border/50 bg-card shadow-sm">
            <Skeleton className="h-48 w-full rounded-t-md" />
            <CardHeader>
              <Skeleton className="mb-2 h-4 w-1/3" />
              <Skeleton className="h-6 w-3/4" />
            </CardHeader>
            <CardContent>
              <Skeleton className="mb-2 h-4 w-full" />
              <Skeleton className="h-4 w-2/3" />
            </CardContent>
            <CardFooter>
              <Skeleton className="h-10 w-full" />
            </CardFooter>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-destructive font-default">
        Gagal memuat berita terkini. Silakan coba lagi.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground font-default">
        Belum ada berita breaking hari ini.
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex h-full flex-col overflow-hidden border-border bg-card shadow-sm transition-all duration-300 hover:shadow-md hover:border-primary/20">
          {post.featuredImage && <div className="overflow-hidden">
              <AspectRatio ratio={16 / 9}>
                <img src={post.featuredImage || `/img/driver_news_${i}.png`} alt={post.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </AspectRatio>
            </div>}
          <CardHeader className="flex-1">
            <div className="mb-4 flex items-center justify-between text-xs text-muted-foreground">
              {post.date && <span className="flex items-center gap-1.5 font-default">
                  <SafeHydrate><Calendar className="size-3.5" /></SafeHydrate>
                  {new Date(post.date).toLocaleDateString("id-ID")}
                </span>}
              {post.categories && post.categories.length > 0 && <Badge variant="outline" className={`border-none font-bold ${post.categories[0].name.toLowerCase() === 'live' ? 'bg-destructive text-destructive-foreground' : post.categories[0].name.toLowerCase() === 'update' ? 'bg-blue-600 text-white' : 'bg-primary text-primary-foreground'}`}>
                  {post.categories[0].name.toUpperCase()}
                </Badge>}
            </div>
            <CardTitle className="font-default text-xl font-bold leading-tight transition-colors group-hover:text-primary">
              {post.title}
            </CardTitle>
            {post.excerpt && <div className="mt-4 line-clamp-3 text-sm text-muted-foreground font-sans" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}
          </CardHeader>
          <CardFooter className="mt-auto pt-0">
            <Link to={post.link || "#"} className="w-full">
              <Button variant="ghost" className="group/btn w-full justify-between text-primary font-semibold hover:bg-primary/5 hover:text-primary">
                Baca Selengkapnya
                <ArrowRight className="size-4 transition-transform group-hover/btn:translate-x-1" />
              </Button>
            </Link>
          </CardFooter>
        </Card>)}
    </div>;
}
export default function BreakingDriver() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="253955" id="breaking-driver" className="relative overflow-hidden bg-background text-foreground py-24">
      {}
      <div className="pointer-events-none absolute top-0 left-1/4 -z-10 h-96 w-96 rounded-lg bg-primary/5 blur-3xl" />
      <div className="pointer-events-none absolute right-1/4 bottom-0 -z-10 h-96 w-96 rounded-lg bg-secondary/5 blur-3xl" />

      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <Badge variant="outline" className="mb-4 border-destructive/30 bg-destructive/10 text-destructive font-bold">
            <BookOpen className="mr-1.5 size-3.5" />
            BREAKING NEWS
          </Badge>
          <h2 className="font-default mb-6 text-3xl font-bold md:text-4xl lg:text-5xl tracking-tight">
            Info Terkini Aspal & Lapangan
          </h2>
          <p className="max-w-2xl text-lg text-muted-foreground font-sans">
            Pantau terus informasi razia, update tarif, kecelakaan, hingga berita viral di kalangan driver. Tetap waspada dan update situasi jalanan secara real-time.
          </p>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3
      }}>
          <PostsGrid />
        </PostsProvider>

        <div className="mt-16 text-center">
          <Link to="#">
            <Button variant="outline" size="lg" className="border-primary/50 text-primary font-bold hover:bg-primary hover:text-primary-foreground transition-all shadow-sm">
              Lihat Semua Berita
              <ArrowRight className="ml-2 size-4" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}